import { IGetState, TBoardId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { patchRest } from '../patchRest';
import { sendAuthUserRealTimeStoreAction } from '../../../../../view/react_components/base/helpers/realTimeHelperTS';
import { IBoardUserMeta } from 'app/store/model/boardUserMeta/types';
import { getBoardUserMetaForRollback } from 'app/store/model/selectors/getBoardUserMetaForRollback';
import { boardUserMetasActionSet } from 'app/store/model/boardUserMetas/actions/boardUserMetaActionSet';
import { updateAction } from 'app/store/model/boardUserMeta/actions/updateAction';
import { boardUserMetasActionSetAction } from 'app/store/model/actions/boardUserMetasActionSetAction';

export const boardUserMetaPatchRest = (
    boardId: TBoardId,
    patchBoardUserMeta: IBoardUserMeta,
    isRealtime: boolean = true
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const boardUserMetaForRollback = getBoardUserMetaForRollback(getState(), boardId, patchBoardUserMeta);

        const action = boardUserMetasActionSetAction(boardUserMetasActionSet(boardId, updateAction(patchBoardUserMeta)));
        dispatch(action);
        return dispatch(patchRest(boardId, { userMeta: patchBoardUserMeta }))
            .then(() => {
                if (isRealtime) {
                    dispatch(sendAuthUserRealTimeStoreAction(action));
                }
            })
            .catch((e: any) => {
                console.error(e);
                dispatch(boardUserMetasActionSetAction(boardUserMetasActionSet(boardId, updateAction(boardUserMetaForRollback))));
            });
    };
    return action;
};
